import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.error.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.date.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.regexp.to-string.js';
import React from 'react';
import '../styles/index.less.js';
import { useMergedState } from 'rc-util';
import classNames from 'classnames';
import { isNumber } from 'lodash';
import TiRadio from '../Radio/index.js';

var RadioGroup = function RadioGroup(props) {
  var _a;
  var value = props.value,
    onChange = props.onChange,
    defaultValue = props.defaultValue,
    _b = props.options,
    options = _b === void 0 ? [] : _b,
    _c = props.direction,
    direction = _c === void 0 ? 'horizontal' : _c,
    disabled = props.disabled,
    className = props.className,
    style = props.style;
  var _d = useMergedState(defaultValue, {
      value: value,
      onChange: onChange
    }),
    state = _d[0],
    setState = _d[1];
  var onRadioChange = function onRadioChange(event) {
    if (disabled) {
      return;
    }
    setState(event.target.value);
  };
  var radioGroupCls = classNames(className, (_a = {}, _a['ti-radio-group-horizontal'] = direction === 'horizontal', _a['ti-radio-group-vertical'] = direction === 'vertical', _a));
  return /*#__PURE__*/React.createElement("div", {
    className: radioGroupCls,
    style: style
  }, options.map(function (x) {
    var currentValue = isNumber(x.value) ? x.value.toString() : x.value;
    var isChecked = currentValue === state;
    return /*#__PURE__*/React.createElement(TiRadio, {
      key: x.value,
      checked: isChecked,
      value: x.value,
      onChange: onRadioChange,
      disabled: disabled || x.disabled
    }, x.label);
  }));
};

export { RadioGroup as default };
